/**
 * Returns background, color, and border values based on a reservation/contact status key.
 * @param {string} statusKey - The status string (e.g. "accepted", "pending", "declined", "paid", "finish")
 * @returns {{ bg: string, color: string, border: string }} Color configuration object
 */
function getStatusColor(statusKey) {
    const colorMap = {
        accepted: { bg: "rgba(76, 175, 80, 0.15)", color: "rgba(76, 175, 80, 1)", border: "rgba(76, 175, 80, 0.4)" },
        pending: { bg: "rgba(255, 152, 0, 0.15)", color: "rgba(255, 152, 0, 1)", border: "rgba(255, 152, 0, 0.4)" },
        declined: { bg: "rgba(244, 67, 54, 0.15)", color: "rgba(244, 67, 54, 1)", border: "rgba(244, 67, 54, 0.4)" },
        paid: { bg: "rgba(33, 150, 243, 0.15)", color: "rgba(33, 150, 243, 1)", border: "rgba(33, 150, 243, 0.4)" },
        finish: { bg: "rgba(156, 39, 176, 0.15)", color: "rgba(156, 39, 176, 1)", border: "rgba(156, 39, 176, 0.4)" }
    };

    return colorMap[statusKey] || {
        bg: "rgba(255, 255, 255, 0.1)",
        color: "rgba(255, 255, 255, 0.8)",
        border: "rgba(255, 255, 255, 0.2)"
    };
}

export default getStatusColor;
